
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35215',
  depVersions: {
  "documents-public-ui": "static-1.35215",
  "atom": "static-1.5385",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2779",
  "client-types": "static-1.496",
  "cssUtils": "static-1.918",
  "customer-data-filters-ui": "static-1.40911",
  "customer-data-objects": "static-1.7990",
  "customer-data-property-utils": "static-1.8400",
  "documents-lib": "static-1.35220",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.367",
  "FormsCommonComponents": "static-1.86550",
  "FormUrlGenerator": "static-2.5026",
  "foundations-theming-specialty": "static-1.2490",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5894",
  "hs-test-utils": "static-1.8330",
  "hub-http": "static-1.6511",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12096",
  "HubStyleTokens": "static-2.11789",
  "I18n": "static-7.1672",
  "icons": "static-2.682",
  "jasmine-immutable": "static-1.3320",
  "jasmine-runner": "static-1.6751",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7451",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3192",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5694",
  "quartz": "static-1.7453",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.4",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5556",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8480",
  "reference-resolvers-lite": "static-1.8401",
  "reporting-data": "static-1.68806",
  "reporting-reports": "static-1.68483",
  "reporting-snowflake": "static-1.57423",
  "reporting-testing-lib": "static-1.10739",
  "reporting-visualizations": "static-1.60881",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9250",
  "sanitize": "static-1.4771",
  "sanitize-text": "static-1.8453",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2045",
  "signup-constants": "static-1.19623",
  "signup-ui-url-generator": "static-2.8360",
  "StyleGuideUI": "static-3.501",
  "superstore": "static-1.5056",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5059",
  "ui-addon-form-validation": "static-1.11281",
  "ui-asset-management-lib": "static-1.11397",
  "ui-images": "static-2.1247",
  "UIComponents": "static-3.8735",
  "usage-tracker": "static-1.7637",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "viral-links-lib": "static-1.7375",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9954",
  "foundations-components": "static-1-ech-accordiontransition-jank.35",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1231",
  "quartz-core": "static-1.6672",
  "quick-fetch": "static-1.4129",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.4966",
  "ui-addon-i18n": "static-1.11446",
  "ui-addon-upgrades": "static-9.18383",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3618",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3730",
  "quartz-webpack": "static-1.3677",
  "foundations-assets": "static-1.5184",
  "foundations-theming": "static-1.4774",
  "hub-http-janus": "static-1.878",
  "hub-http-shared-msw-handlers": "static-1.10613",
  "hubspotter-http": "static-1.4863",
  "sassPrefix": "static-1.191",
  "conversations-skeleton-state": "static-1.7544",
  "crm-message-bus": "static-1.43750",
  "customer-data-filters-ui-msw-helpers": "static-1.23346",
  "customer-data-objects-ui-components": "static-1.13329",
  "customer-data-reference-ui-components": "static-1.13476",
  "customer-data-ui-utilities": "static-1.10128",
  "events-data-lib": "static-1.543",
  "framework-builder-read-service-client": "static-1.4219",
  "hs-resources": "static-1.491",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4052",
  "multi-account-reference-resolvers": "static-1.1303",
  "onboarding-scopes": "static-1.6752",
  "onboarding-tours": "static-1.17115",
  "pulse": "static-1.928",
  "reporting-datasets-permissions-lib": "static-1.14456",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2632",
  "trellis-components": "static-1.2651",
  "trellis-theming": "static-1.1273",
  "ui-addon-teams": "static-1.21905",
  "quartz-auth": "static-1.1128",
  "ui-business-units-lib": "static-1.9387",
  "usage-tracker-session-replay": "static-1.5323",
  "ai-components-ui-library": "static-1.9708",
  "ContentUtils": "static-1.69119",
  "customer-data-properties": "static-1.52580",
  "forms-ai-lib": "static-1.4759",
  "forms-utils-lib": "static-1.13090",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.35",
  "react-dnd-compat": "static-1.4916",
  "react-tinymce": "static-1.55972",
  "tinymce-config": "static-2.55098",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3759",
  "HeadJS": "static-2.796",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3441",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.293",
  "ui-fonts": "static-1.1051",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4612",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1118",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1842",
  "external-options-client-types": "static-1.4338",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7192",
  "quartz-i18n": "static-1.1128",
  "frontend-preferences-client": "static-1.8222",
  "graphql": "static-1.89",
  "persist-promise": "static-1.3999",
  "reporting-client-types": "static-1.2685",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26172",
  "hubspot-apollo-client": "static-1.5176",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.35",
  "quartz-routing": "static-1.883",
  "hs-story-utils": "static-1.9723",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.533",
  "seat-types-lib": "static-1.716",
  "timezone-utils": "static-2.5543",
  "react-create-root-preference": "static-1.69",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.35",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.69",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.444",
  "quartz-test": "static-1.1128",
  "quartz-tracking": "static-1.832",
  "bend-plugin-chirp-manifest": "static-1.376",
  "chirp-fetch": "static-1.2193",
  "merchandise-lib": "static-1.277",
  "purchase-motions-components": "static-1.6361",
  "salesImages": "static-1.561",
  "ts-schema": "static-1.4292",
  "bender-build-tools": "static-1.3441",
  "bend-plugin-foundations-theming": "static-1.3257",
  "restore-request-side-panel-lib": "static-1.1670",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4954",
  "conditional-properties-service-client": "static-1.4013",
  "crm-pipelines-api-client-types": "static-1.4347",
  "event-emitter": "static-1.1252",
  "fdsr-migration-layer": "static-1.311",
  "multi-currency-client-types": "static-1.3908",
  "getting-started-shared-tasks": "static-1.19231",
  "growth-data-modal": "static-1.5893",
  "growth-onboarding-confetti": "static-1.3360",
  "growth-onboarding-next-action-utils": "static-1.2679",
  "navigation-components": "static-1.18823",
  "onboarding-tours-client": "static-1.5330",
  "onboarding-tours-utils": "static-1.1182",
  "ui-shepherd-react": "static-3.10569",
  "ui-shepherd-tracker": "static-1.7950",
  "ui-universal-auth": "static-1.9403",
  "user-context": "static-1.5419",
  "bend-plugin-pulse": "static-1.431",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.139",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10611",
  "magpie-lib": "static-1.5752",
  "navigation-messaging": "static-1.8150",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23008",
  "copilot-toolkit": "static-1.11845",
  "cms-field-types": "static-1.5113",
  "content-icons-ui": "static-1.2362",
  "integrations-lib": "static-1.17020",
  "calling-global-api": "static-1.65606",
  "calling-internal-common": "static-1.31619",
  "calling-lifecycle-internal": "static-1.66988",
  "calling-lifecycle-messages": "static-1.59282",
  "commerce-products-lib": "static-1.10518",
  "crm-index-visualization-core": "static-1.4538",
  "crm-links": "static-1.6628",
  "customer-data-properties-shared-msw-handlers": "static-1.9940",
  "file-manager-components": "static-1.24485",
  "formula-editor": "static-1.14764",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4425",
  "meetings-icalendar-utils-lib": "static-1.935",
  "object-builder-ui-client": "static-1.49665",
  "pipeline-validation-client-types": "static-1.4181",
  "property-value-citations": "static-1.3194",
  "smart-data-capture-core": "static-1.135",
  "smart-property-lib": "static-1.8287",
  "tiered-pricing": "static-1.1950",
  "topics-actions-lib": "static-1.464",
  "trial-components-library": "static-1.14104",
  "ui-addon-iframeable": "static-1.9375",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20302",
  "tinymce-themes": "static-1.57068",
  "data-token-picker": "static-1.16885",
  "hub-http-contrib": "static-1.3337",
  "interframe": "static-3.5054",
  "tinymce-data": "static-1.41183",
  "tinymce-plugins": "static-1.58212",
  "ui-addon-sales-email": "static-1.5510",
  "framework-data-schema-quick-fetch": "static-1.7097",
  "ui-addon-opt": "static-4.8662",
  "hubspot-apollo-cache": "static-1.635",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.448",
  "opentelemetry-web": "static-1.13",
  "purchase-motions-api": "static-1.6364",
  "onboarding-data-sync-lib": "static-1.2508",
  "growth-onboarding-next-action-components": "static-1.2707",
  "user-context-client": "static-1.4805",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5212",
  "nest": "static-1.536",
  "reactive-lib": "static-1.1017",
  "simple-logging-lib": "static-1.3350",
  "unified-auth-core-lib": "static-1.1199",
  "getting-started-shared-tasks-store": "static-1.18349",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1725",
  "integrations-error-boundary-lib": "static-1.14435",
  "integrations-tracking-lib": "static-1.5906",
  "native-integrations-shared-strings": "static-1.8076",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10669",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.917",
  "calling-error-reporting": "static-1.31626",
  "shared-worker-versioning": "static-1.11340",
  "calling-usage-tracker": "static-1.6835",
  "voice-sms-access-library": "static-1.2044",
  "customer-data-tracking": "static-1.7181",
  "commerce-permissions": "static-1.1076",
  "products-iframe-lib": "static-1.8584",
  "products-ui-components-shared-msw-handlers": "static-1.10995",
  "crm-index-associations-lib": "static-1.6740",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10696",
  "sales-views-client-types": "static-1.4556",
  "location-customization-utils-lib": "static-1.10088",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4447",
  "video-components-external": "static-1.12142",
  "video-data-lib": "static-1.35800",
  "bark-lib": "static-1.16811",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6187",
  "react-codemirror": "static-1.10939",
  "data-agent-kit": "static-1.646",
  "feedback-loader": "static-1.29808",
  "fsm": "static-1.4048",
  "policy-lib": "static-1.7100",
  "react-colorpicker": "static-2.10517",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10759",
  "embedded-academy-lib": "static-1.15504",
  "hubs-service-types": "static-1.1558",
  "FileManagerLib": "static-1.40125",
  "NamespacedHubStyle": "static-2.9263",
  "FileManagerCore": "static-1.39984",
  "content-assistance-lib": "static-1.8196",
  "layout-dnd-components": "static-1.12964",
  "layout-dnd-utils": "static-1.11939",
  "ui-addon-emoji-picker": "static-1.10185",
  "ui-brand-identity-lib": "static-1.16465",
  "InboxConnectUtils": "static-4.15552",
  "meetings-connect-utils-lib": "static-1.7908",
  "breeze-engine-chat-components": "static-1.703",
  "breeze-engine-core": "static-1.1003",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3307",
  "adobe-sign-auth-lib": "static-1.451",
  "ads-unified-auth-lib": "static-1.1345",
  "generic-oauth-auth-lib": "static-1.45",
  "google-sheets-integration-lib": "static-1.1021",
  "microsoft-drive-auth-lib": "static-1.135",
  "surveymonkey-integration-lib": "static-1.479",
  "slack-ui-library": "static-1.10698",
  "calling-orchestration-schema": "static-1.36821",
  "crm-record-cards-service-types": "static-1.3785",
  "content-media-composition-data-lib": "static-1.13232",
  "content-media-compositions": "static-2.17239",
  "media-bridge-lib": "static-1.19403",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16355",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4807",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.14964",
  "audio-components": "static-1.6340",
  "FileManagerImages": "static-1.37636",
  "video-components": "static-1.14144",
  "breeze-artifacts-sdk": "static-1.323",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4831",
  "video-embed": "static-1.36634",
  "ui-addon-video-player": "static-1.9002",
  "ui-coaching-tips": "static-1.29297",
  "ContentData": "static-1.69194",
  "layout-data-lib": "static-1.10264",
  "academy-service-client": "static-1.3986",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4702",
  "trellis-ecosystem": "static-1.7624",
  "ui-addon-react-router-dom": "static-1.9835",
  "wootric-nps": "static-1.7199",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4454",
  "growth-onboarding-feedback-components": "static-1.6883",
  "advanced-menus-core": "static-1.15573",
  "advanced-menus-lib": "static-1.12447",
  "ExportDialog": "static-6.10677",
  "ui-memberships-settings-lib": "static-1.34834",
  "marketplace-ui-apps-core": "static-1.19254",
  "marketplace-ui-common": "static-1.20722",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15572",
  "simple-menus-lib": "static-1.17089",
  "developer-experience-shared-components": "static-1.10828",
  "immutable-less": "static-1.4948",
  "marketplace-ui-client-types": "static-1.18129",
  "ui-addon-integrations-directory-panel": "static-2.8325",
  "ui-extensibility-client-types": "static-1.4217",
  "ai-settings-ui-library": "static-1.8348",
  "nav-meta": "static-1.30460",
  "ui-product-approvals-common": "static-1.1040",
  "apps-service-types": "static-1.4038",
  "oauth-service-types": "static-1.4537",
  "simple-data-table": "static-1.3524"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35215",
  "atom": "/atom/static-1.5385",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2779",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.918",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40911",
  "customer-data-objects": "/customer-data-objects/static-1.7990",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8400",
  "documents-lib": "/documents-lib/static-1.35220",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.367",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86550",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5026",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2490",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5894",
  "hs-test-utils": "/hs-test-utils/static-1.8330",
  "hub-http": "/hub-http/static-1.6511",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12096",
  "HubStyleTokens": "/HubStyleTokens/static-2.11789",
  "I18n": "/I18n/static-7.1672",
  "icons": "/icons/static-2.682",
  "jasmine-immutable": "/jasmine-immutable/static-1.3320",
  "jasmine-runner": "/jasmine-runner/static-1.6751",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7451",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3192",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5694",
  "quartz": "/quartz/static-1.7453",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.4",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5556",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8480",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8401",
  "reporting-data": "/reporting-data/static-1.68806",
  "reporting-reports": "/reporting-reports/static-1.68483",
  "reporting-snowflake": "/reporting-snowflake/static-1.57423",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10739",
  "reporting-visualizations": "/reporting-visualizations/static-1.60881",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9250",
  "sanitize": "/sanitize/static-1.4771",
  "sanitize-text": "/sanitize-text/static-1.8453",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2045",
  "signup-constants": "/signup-constants/static-1.19623",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8360",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "superstore": "/superstore/static-1.5056",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5059",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11281",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11397",
  "ui-images": "/ui-images/static-2.1247",
  "UIComponents": "/UIComponents/static-3.8735",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "viral-links-lib": "/viral-links-lib/static-1.7375",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9954",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.35",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1231",
  "quartz-core": "/quartz-core/static-1.6672",
  "quick-fetch": "/quick-fetch/static-1.4129",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.4966",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11446",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18383",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3618",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3730",
  "quartz-webpack": "/quartz-webpack/static-1.3677",
  "foundations-assets": "/foundations-assets/static-1.5184",
  "foundations-theming": "/foundations-theming/static-1.4774",
  "hub-http-janus": "/hub-http-janus/static-1.878",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10613",
  "hubspotter-http": "/hubspotter-http/static-1.4863",
  "sassPrefix": "/sassPrefix/static-1.191",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7544",
  "crm-message-bus": "/crm-message-bus/static-1.43750",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23346",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13329",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13476",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10128",
  "events-data-lib": "/events-data-lib/static-1.543",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4219",
  "hs-resources": "/hs-resources/static-1.491",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4052",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1303",
  "onboarding-scopes": "/onboarding-scopes/static-1.6752",
  "onboarding-tours": "/onboarding-tours/static-1.17115",
  "pulse": "/pulse/static-1.928",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14456",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2632",
  "trellis-components": "/trellis-components/static-1.2651",
  "trellis-theming": "/trellis-theming/static-1.1273",
  "ui-addon-teams": "/ui-addon-teams/static-1.21905",
  "quartz-auth": "/quartz-auth/static-1.1128",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9387",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9708",
  "ContentUtils": "/ContentUtils/static-1.69119",
  "customer-data-properties": "/customer-data-properties/static-1.52580",
  "forms-ai-lib": "/forms-ai-lib/static-1.4759",
  "forms-utils-lib": "/forms-utils-lib/static-1.13090",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.35",
  "react-dnd-compat": "/react-dnd-compat/static-1.4916",
  "react-tinymce": "/react-tinymce/static-1.55972",
  "tinymce-config": "/tinymce-config/static-2.55098",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3759",
  "HeadJS": "/HeadJS/static-2.796",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3441",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.293",
  "ui-fonts": "/ui-fonts/static-1.1051",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4612",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1118",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1842",
  "external-options-client-types": "/external-options-client-types/static-1.4338",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7192",
  "quartz-i18n": "/quartz-i18n/static-1.1128",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8222",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.3999",
  "reporting-client-types": "/reporting-client-types/static-1.2685",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26172",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5176",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.35",
  "quartz-routing": "/quartz-routing/static-1.883",
  "hs-story-utils": "/hs-story-utils/static-1.9723",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.533",
  "seat-types-lib": "/seat-types-lib/static-1.716",
  "timezone-utils": "/timezone-utils/static-2.5543",
  "react-create-root-preference": "/react-create-root-preference/static-1.69",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.35",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.69",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.444",
  "quartz-test": "/quartz-test/static-1.1128",
  "quartz-tracking": "/quartz-tracking/static-1.832",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.376",
  "chirp-fetch": "/chirp-fetch/static-1.2193",
  "merchandise-lib": "/merchandise-lib/static-1.277",
  "purchase-motions-components": "/purchase-motions-components/static-1.6361",
  "salesImages": "/salesImages/static-1.561",
  "ts-schema": "/ts-schema/static-1.4292",
  "bender-build-tools": "/bender-build-tools/static-1.3441",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3257",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1670",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4954",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4013",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4347",
  "event-emitter": "/event-emitter/static-1.1252",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.311",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3908",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19231",
  "growth-data-modal": "/growth-data-modal/static-1.5893",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3360",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2679",
  "navigation-components": "/navigation-components/static-1.18823",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5330",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1182",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10569",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7950",
  "ui-universal-auth": "/ui-universal-auth/static-1.9403",
  "user-context": "/user-context/static-1.5419",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.431",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.139",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10611",
  "magpie-lib": "/magpie-lib/static-1.5752",
  "navigation-messaging": "/navigation-messaging/static-1.8150",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23008",
  "copilot-toolkit": "/copilot-toolkit/static-1.11845",
  "cms-field-types": "/cms-field-types/static-1.5113",
  "content-icons-ui": "/content-icons-ui/static-1.2362",
  "integrations-lib": "/integrations-lib/static-1.17020",
  "calling-global-api": "/calling-global-api/static-1.65606",
  "calling-internal-common": "/calling-internal-common/static-1.31619",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66988",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59282",
  "commerce-products-lib": "/commerce-products-lib/static-1.10518",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4538",
  "crm-links": "/crm-links/static-1.6628",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9940",
  "file-manager-components": "/file-manager-components/static-1.24485",
  "formula-editor": "/formula-editor/static-1.14764",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4425",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.935",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49665",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4181",
  "property-value-citations": "/property-value-citations/static-1.3194",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.135",
  "smart-property-lib": "/smart-property-lib/static-1.8287",
  "tiered-pricing": "/tiered-pricing/static-1.1950",
  "topics-actions-lib": "/topics-actions-lib/static-1.464",
  "trial-components-library": "/trial-components-library/static-1.14104",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9375",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20302",
  "tinymce-themes": "/tinymce-themes/static-1.57068",
  "data-token-picker": "/data-token-picker/static-1.16885",
  "hub-http-contrib": "/hub-http-contrib/static-1.3337",
  "interframe": "/interframe/static-3.5054",
  "tinymce-data": "/tinymce-data/static-1.41183",
  "tinymce-plugins": "/tinymce-plugins/static-1.58212",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5510",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7097",
  "ui-addon-opt": "/ui-addon-opt/static-4.8662",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.635",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.448",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "purchase-motions-api": "/purchase-motions-api/static-1.6364",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2508",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2707",
  "user-context-client": "/user-context-client/static-1.4805",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5212",
  "nest": "/nest/static-1.536",
  "reactive-lib": "/reactive-lib/static-1.1017",
  "simple-logging-lib": "/simple-logging-lib/static-1.3350",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1199",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18349",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1725",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14435",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5906",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8076",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10669",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.917",
  "calling-error-reporting": "/calling-error-reporting/static-1.31626",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11340",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6835",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2044",
  "customer-data-tracking": "/customer-data-tracking/static-1.7181",
  "commerce-permissions": "/commerce-permissions/static-1.1076",
  "products-iframe-lib": "/products-iframe-lib/static-1.8584",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10995",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6740",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10696",
  "sales-views-client-types": "/sales-views-client-types/static-1.4556",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10088",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4447",
  "video-components-external": "/video-components-external/static-1.12142",
  "video-data-lib": "/video-data-lib/static-1.35800",
  "bark-lib": "/bark-lib/static-1.16811",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6187",
  "react-codemirror": "/react-codemirror/static-1.10939",
  "data-agent-kit": "/data-agent-kit/static-1.646",
  "feedback-loader": "/feedback-loader/static-1.29808",
  "fsm": "/fsm/static-1.4048",
  "policy-lib": "/policy-lib/static-1.7100",
  "react-colorpicker": "/react-colorpicker/static-2.10517",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10759",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15504",
  "hubs-service-types": "/hubs-service-types/static-1.1558",
  "FileManagerLib": "/FileManagerLib/static-1.40125",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9263",
  "FileManagerCore": "/FileManagerCore/static-1.39984",
  "content-assistance-lib": "/content-assistance-lib/static-1.8196",
  "layout-dnd-components": "/layout-dnd-components/static-1.12964",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11939",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10185",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16465",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15552",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7908",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.703",
  "breeze-engine-core": "/breeze-engine-core/static-1.1003",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3307",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.451",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1345",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.45",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1021",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.135",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.479",
  "slack-ui-library": "/slack-ui-library/static-1.10698",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36821",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3785",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13232",
  "content-media-compositions": "/content-media-compositions/static-2.17239",
  "media-bridge-lib": "/media-bridge-lib/static-1.19403",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16355",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4807",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.14964",
  "audio-components": "/audio-components/static-1.6340",
  "FileManagerImages": "/FileManagerImages/static-1.37636",
  "video-components": "/video-components/static-1.14144",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.323",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4831",
  "video-embed": "/video-embed/static-1.36634",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9002",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29297",
  "ContentData": "/ContentData/static-1.69194",
  "layout-data-lib": "/layout-data-lib/static-1.10264",
  "academy-service-client": "/academy-service-client/static-1.3986",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4702",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7624",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9835",
  "wootric-nps": "/wootric-nps/static-1.7199",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4454",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6883",
  "advanced-menus-core": "/advanced-menus-core/static-1.15573",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12447",
  "ExportDialog": "/ExportDialog/static-6.10677",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34834",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19254",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20722",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15572",
  "simple-menus-lib": "/simple-menus-lib/static-1.17089",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10828",
  "immutable-less": "/immutable-less/static-1.4948",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18129",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8325",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4217",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8348",
  "nav-meta": "/nav-meta/static-1.30460",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1040",
  "apps-service-types": "/apps-service-types/static-1.4038",
  "oauth-service-types": "/oauth-service-types/static-1.4537",
  "simple-data-table": "/simple-data-table/static-1.3524"
}
};
